@import "config";

.container {
	@include flex(row, unset, center);

	flex-wrap: wrap;
	gap: $spacing-inline-quarck;
	min-height: 40px;
	padding: $spacing-inset-quarck;
	border: 2px dashed $color-dark-d2;
	border-radius: $border-radius-sm;
	background: $color-light-l3;
	cursor: pointer;

	span {
		width: 100%;
		text-align: center;
		font-style: italic;
	}
}

.accept {
	border: 2px dashed $color-success-light;
}

.reject {
	border: 2px dashed $color-error-medium;
}
